import { Col, DatePicker, Modal, Row } from "antd";
import React, { useEffect } from "react";
import InputSearchBox from "../Input/InputSearchBox";
import SelectValue from "../Selector/SelectValue";
import { timeSelectSort } from "../../../utils/ValueSelect";
import { useState } from "react";
import moment from "moment";
import BaseButton from "../Button/BaseButton";
import { IconPlus } from "../../../assets/icon";

const HeaderChatBkavPro = ({ setConfig, config, handleClick }) => {
  const dateFormat = "DD/MM/YYYY";
  const [isSelectTime, setIsSelectTime] = useState(false);
  const [valueTime, setValueTime] = useState(-1);
  const [timeSelect, setTimeSelect] = useState({
    type: 0,
    timeStart: "",
    timeEnd: "",
  });
  const startTime = moment(timeSelect.timeStart, "YYYY-MM-DD HH:mm:ss");
  const endTime = moment(timeSelect.timeEnd, "YYYY-MM-DD HH:mm:ss");
  useEffect(() => {
    if (timeSelect.timeStart && timeSelect.timeEnd) {
      if (moment.duration(endTime.diff(startTime)).days() >= 0) {
        setConfig({
          ...config,
          timeStart: moment(timeSelect.timeStart).format("YYYY-MM-DDT00:00:00"),
          timeEnd: moment(timeSelect.timeEnd).format("YYYY-MM-DDT23:59:59"),
          page: 0,
          size: 10,
        });
      } else {
        Modal.error({
          className: "wrapperModalErrConfigBanner",
          centered: true,
          width: 590,
          title: <span style={{ fontSize: 20, fontWeight: 700 }}>Lỗi</span>,
          content: (
            <p style={{ fontSize: 20 }}>
              Thời gian bắt đầu và thời gian kết thúc không hợp lệ!
            </p>
          ),
        });
      }
    }
  }, [timeSelect.timeEnd, timeSelect.timeStart]);
  return (
    <Row style={{ width: "100%" }} justify={"space-between"}>
      <Col className="mr-5">
        <InputSearchBox
          width={435}
          setText={(value) =>
            setConfig({
              ...config,
              page: 0,
              size: 10,
              search: value,
            })
          }
          placeholder="Tìm kiếm theo tiêu đề"
          key={"searchDeal"}
        />
      </Col>
      <Col
        style={{
          flexGrow: "1",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <span
          style={{
            marginRight: "1.6rem",
            fontWeight: "400",
            color: "rgba(0, 0, 0, 1)",
          }}
          className="ml-5"
        >
          Thời gian
        </span>
        <SelectValue
          width={185}
          handleChange={(value) => {
            setValueTime(value);

            if (value !== 0) {
              let timeStart = "";
              let timeEnd = moment().format("YYYY-MM-DDT23:59:59");
              if (value === 1) {
                timeStart = moment().subtract(1, "month").calendar();
              } else if (value === 2) {
                timeStart = moment().subtract(3, "month").calendar();
              } else if (value === 3) {
                timeStart = moment().subtract(6, "month").calendar();
              } else if (value === 4) {
                timeStart = moment().subtract(1, "year").calendar();
              } else if (value === 5) {
                timeStart = moment().format("YYYY-MM-DDT00:00:00");
              } else if (value === 6) {
                var today = new Date();

                var yesterday = new Date(today);

                yesterday.setDate(today.getDate() - 1);

                var year = yesterday.getFullYear();
                var month = yesterday.getMonth() + 1; // Tháng bắt đầu từ 0
                var day = yesterday.getDate();
                timeStart = `${month}/${day}/${year}`;
                timeEnd = `${month}/${day}/${year}`;
              } else if (value === 7) {
                timeStart = moment().subtract(7, "days").calendar();
              }
              setIsSelectTime(false);
              setConfig({
                ...config,
                timeStart:
                  value === -1
                    ? 0
                    : moment(timeStart).format("YYYY-MM-DDT00:00:00"),
                timeEnd:
                  value === -1
                    ? 0
                    : moment(timeEnd).format("YYYY-MM-DDT23:59:59"),
              });
            } else {
              setIsSelectTime(true);
            }
          }}
          value={valueTime}
          defaultValue={timeSelectSort[0].label}
          type={"selectGray mr-5"}
          optionsValue={timeSelectSort}
        />
        {isSelectTime ? (
          <>
            <span
              style={{
                marginRight: "1.6rem",
                fontWeight: "400",
                color: "rgba(0, 0, 0, 1)",
              }}
            >
              Từ
            </span>
            <DatePicker
              // defaultValue={dayjs("2015/01/01", dateFormat)}
              onChange={(value) => {
                if (value) {
                  setTimeSelect({
                    ...timeSelect,
                    timeStart: value.format("YYYY-MM-DD 00:00:00"),
                  });
                } else {
                  setTimeSelect({
                    ...timeSelect,
                    timeStart: "",
                  });
                }
              }}
              style={{
                borderRadius: "33px",
                background: "rgba(240, 240, 240, 1)",
                color: "rgba(130, 130, 130, 1)",
                height: "34px",
              }}
              format={dateFormat}
              className="mr-5"
            />
            <span
              style={{
                marginRight: "1.6rem",
                fontWeight: "400",
                color: "rgba(0, 0, 0, 1)",
              }}
            >
              đến
            </span>
            <DatePicker
              // defaultValue={dayjs("2015/01/01", dateFormat)}
              style={{
                borderRadius: "33px",
                background: "rgba(240, 240, 240, 1)",
                color: "rgba(130, 130, 130, 1)",
                height: "34px",
              }}
              format={dateFormat}
              onChange={(value) => {
                if (value) {
                  setTimeSelect({
                    ...timeSelect,
                    timeEnd: value.format("YYYY-MM-DD 23:59:59"),
                  });
                } else {
                  setTimeSelect({
                    ...timeSelect,
                    timeEnd: "",
                  });
                }
              }}
            />
          </>
        ) : null}
      </Col>

      <Col style={{ flexGrow: 1, display: "flex", justifyContent: "end" }}>
        <BaseButton
          handleClick={handleClick}
          icon={
            <IconPlus
              width={16}
              height={14}
              style={{ marginRight: "0.5rem" }}
            />
          }
          content={`Thêm mới`}
          width={120}
          typeBtn="btnOrange"
        />
      </Col>
    </Row>
  );
};

export default HeaderChatBkavPro;
